import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import Home from "@/pages/Home";
import InvoiceEntry from "@/pages/InvoiceEntry";
import GroupALanding from "@/pages/GroupALanding";
import GroupBLanding from "@/pages/GroupBLanding";
import SelectFulfillment from "@/pages/SelectFulfillment";
import DeliveryForm from "@/pages/DeliveryForm";
import Success from "@/pages/Success";
import Review from "@/pages/Review";
import PickupForm from "@/pages/PickupForm";
import PickupSuccess from "@/pages/PickupSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import api from "@/lib/api";
import "@/App.css";

// Auth gate is async because the session lives in an HttpOnly cookie —
// the browser JS cannot read it. We probe /api/admin/me on mount; a 200
// means the cookie is valid on the server side, a 401 means signed out.
const RequireAdmin = ({ children }) => {
  const [status, setStatus] = useState("checking"); // "checking" | "ok" | "no"
  useEffect(() => {
    let cancelled = false;
    api.get("/admin/me")
      .then(() => { if (!cancelled) setStatus("ok"); })
      .catch(() => { if (!cancelled) setStatus("no"); });
    return () => { cancelled = true; };
  }, []);
  if (status === "checking") {
    return (
      <div
        className="min-h-screen bg-ivory flex items-center justify-center"
        data-testid="admin-auth-checking"
      >
        <Loader2 className="animate-spin text-maroon" size={22} />
      </div>
    );
  }
  if (status === "no") return <Navigate to="/admin/login" replace />;
  return children;
};

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/invoice" element={<InvoiceEntry />} />
        <Route path="/group-a" element={<GroupALanding />} />
        <Route path="/group-b" element={<GroupBLanding />} />
        <Route path="/select" element={<SelectFulfillment />} />
        <Route path="/delivery" element={<DeliveryForm />} />
        <Route path="/success" element={<Success />} />
        <Route path="/review" element={<Review />} />
        <Route path="/pickup" element={<PickupForm />} />
        <Route path="/pickup/success" element={<PickupSuccess />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminDashboard />
            </RequireAdmin>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
